module.exports = __webpack_public_path__ + "img/MES3Indice2_cutout.f875b121.png";